
import * as React from 'react';

type IconCartProps = React.SVGProps<SVGSVGElement>;

export const IconCart: React.FC<IconCartProps> = (props) => (
	<svg width={37} height={30} viewBox="0 0 37 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="25.6445" y="0.863525" width="7.67735" height="7.67734" rx="1.09676" transform="rotate(25.4195 25.6445 0.863525)" fill="#FFA692"/>
		<ellipse cx="16.8652" cy="8.13372" rx="5.48382" ry="5.48382" fill="#FFA692"/>
		<path d="M6.99414 7.20557H32.7526C34.1633 7.20557 35.2072 8.51783 34.89 9.89233L32.6121 19.7632C32.3824 20.7585 31.4962 21.4635 30.4747 21.4635H10.2844L6.99414 7.20557Z" fill="#EFF4F1"/>
		<path d="M32.1996 25.0645H13.96C12.4364 25.0645 11.1121 24.0185 10.7592 22.5363L5.87729 2.03247H1.49023" stroke="#8BA293" stroke-width="2.19353" stroke-linecap="round" stroke-linejoin="round"/>
		<ellipse cx="14.6515" cy="27.8066" rx="2.19353" ry="2.19353" fill="#8BA293"/>
		<ellipse cx="27.8127" cy="27.8066" rx="2.19353" ry="2.19353" fill="#8BA293"/>
	</svg>

);


